<template lang="pug">
  sui-container
    transition(name="fade")
      sui-dimmer(
        inverted,
        active,
        v-if="loading")
        sui-loader Loading...

    nav-menu(
      v-if="!loading",
      :options="options.stage",
      :value="selected.stage.stageId",
      @change="selectStageWeek($event)")

    nav-menu(
      v-if="!loading && options.week.length",
      :options="options.week",
      :value="selected.week.weekId",
      @change="selectStageWeek(null, $event)")

    matches-table(
      v-if="!loading",
      :matches="displayedMatches"
      @selectMatch="navigate")
</template>

<script>
import NavMenu from '@/components/NavMenu.vue';
import MatchesTable from '@/components/matches/MatchesTable.vue';

export default {
  name: 'matches',
  components: {
    NavMenu,
    MatchesTable,
  },
  data() {
    return {};
  },
  created() {
    this.selectInitialStageWeek();
  },
  computed: {
    matches() {
      return this.$store.state.matches;
    },
    teams() {
      return this.$store.state.teams;
    },
    stages() {
      return this.$store.state.stages;
    },
    loading() {
      return this.$store.state.loading;
    },
    selected() {
      return {
        stage: this.$store.state.stage,
        week: this.$store.state.week,
      };
    },
    options() {
      return {
        stage: this.stages.map(stage => ({
          name: stage.name,
          key: stage.stageId,
          disabled: !stage.enabled,
        })),
        week: this.selected.stage.weeks.map(week => ({
          name: week.name,
          key: week.weekId,
        })),
      };
    },
    displayedMatches() {
      if (!this.selected.stage || !this.selected.week) {
        return [];
      }

      return this.matches
        .filter(x => x.stageId === this.selected.stage.stageId)
        .filter(x => x.weekId === this.selected.week.weekId)
        // .filter(x => x.teams[0])
        .map(match => ({
          ...match,
          teams: match.teams.map(teamId => this.teams.find(x => x.teamId === teamId)),
        }))
        .sort((x, y) => new Date(x.startDate) - new Date(y.startDate));
    },
  },
  methods: {
    selectStageWeek(stageId = 0, weekId = 0) {
      let stage = this.stages.find(x => x.stageId === stageId);
      if (!stage) {
        stage = this.selected.stage;
      }

      const week = stage.weeks.find(x => x.weekId === weekId);
      this.$store.commit('SET_STAGE_WEEK', { stage, week });
    },
    selectInitialStageWeek() {
      if (
        this.stages.length &&
        this.matches.length &&
        !this.selected.stage &&
        !this.selected.week
      ) {
        const match = this.matches.find(x => x.state === 'PENDING');

        if (match) {
          this.selectStageWeek(match.stageId, match.weekId);
        } else {
          this.selectStageWeek();
        }
      }
    },
    navigate(matchId) {
      this.$router.push({ name: 'match', params: { matchId } });
    },
  },
  watch: {
    matches() {
      this.selectInitialStageWeek();
    },
    stages() {
      this.selectInitialStageWeek();
    },
  },
};
</script>
